import script from "./WapCookView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapCookView.vue?vue&type=script&lang=ts&setup=true"

import "./WapCookView.vue?vue&type=style&index=0&id=00e9ec23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e9ec23"]])

export default __exports__